import React, { useState } from 'react';
import { useSelector } from "react-redux";
import { Button } from "@mui/material";
import _ from "lodash";
import { RemoveProjectManager } from './removeProject';
import { UnlistAccountProjectManager } from './unlistAccount';
import { AssignProject } from './assignProject';
import { CommonModal } from "src/components/modal";
import IconManagerAllocate from "src/assets/images/icon_managerallocate.svg";
import IconEditRecord from "src/assets/images/icon_editrecord.svg";
import IconRemove from "src/assets/images/icon_remove.svg";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";

export const ProjectManagerDetailView = ({ getAllClientsData, handleBackButtonClick, handleViewRecordButtonClick, setOpen, setIsEditTextShown, selectedData }) => {

      /** redux store useDispatch & useSelector ------------------------------ **/
      const { individualDepotPersonnelInfo } = useSelector((state) => state.depotUsers);
      const { signoutModelOpenFlag } = useSelector((state) => state.auth);

      /** hooks useState ----------------------------------------------------- **/
      const [unlistAccountModal, setUnlistAccountModel] = useState(false);
      const [assignProjectModel, setAssignProjectModel] = useState(false);
      const [isRemoveProjectButtonClick, setIsRemoveProjectButtonClick] = useState(false)
      const [selectedRemoveProjectInfo, setSelectedRemoveProjectInfo] = useState([])

      /** handler functions--------------------------------------------------- **/

      /** Function to handle image errors ---------------------- **/
      const imgError = (image) => {
            image.onerror = "";
            image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
            return true;
      }

      const handleUnlistAccount = () => {
            setUnlistAccountModel(!unlistAccountModal)
      }

      const handleUnlistAccountClick = () => {
            setUnlistAccountModel(true);
      };

      const handleRemoveProject = () => {
            setIsRemoveProjectButtonClick(!isRemoveProjectButtonClick)
      }

      const handlRemoveProjectClick = (item) => {
            setIsRemoveProjectButtonClick(true);
            setSelectedRemoveProjectInfo(item)
      };


      const handleAssignProject = () => {
            setAssignProjectModel(!assignProjectModel)
      }

      const handleAssignProjectClick = () => {
            setAssignProjectModel(true);
      };

      /** Function to retrieve client names ------------------- **/
      const showClientName = () => {
            const uniqueClientNames = _.union(_.map(individualDepotPersonnelInfo?.projects || "", (d) => d.clientName))
            const formattedClientNames = uniqueClientNames.join(', ');
            return formattedClientNames;

      }

      const handleEditProjectManagerClick = () => {
            setOpen(true);
            setIsEditTextShown(true);
      };

      return <>
            <div className={`main-details-div-for-goodsin ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""}`}>
                  <div className="row">
                        <div className="d-flex justify-content-center first-row-details-goodsin-page" onClick={() => handleBackButtonClick()}>
                              <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
                                    <img src={IconLeftArrow} alt="left arrow" />
                              </div>
                        </div>

                        <div className="admin-details-subdiv-style">
                              <div className="edit-depot-perosonel-img-style">
                                    <img className="edit-record-depot-persoanl-img"
                                          src={individualDepotPersonnelInfo?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                                          onError={imgError} />
                              </div>

                              <div className="d-flex flex-row justify-content-between edit-depotheader align-items-center">
                                    <div className="depotname-section">
                                          {individualDepotPersonnelInfo?.firstName || ""} {individualDepotPersonnelInfo?.middleName || ""} {individualDepotPersonnelInfo?.lastName || ""}
                                    </div>
                                    <div className="me-3">
                                          <span className="me-2 address-main-header-text">WEB-APP</span>
                                          <span className="address-subsection text-uppercase">{individualDepotPersonnelInfo?.projects?.some((project) => project.grantAppAccess === true) ? "ACTIVE" : "INACTIVE"}</span>

                                    </div>
                              </div>

                              <div className="add-space-margin-top-space">
                                    <div className="d-flex flex-column">
                                          <span className="address-main-header-text">CLIENT</span>
                                          <div className="address-subsection">
                                                {showClientName()}
                                          </div>
                                    </div>
                              </div>

                              <div className="add-space-margin-top-basic-details">
                                    <div className="d-flex space-header-section">
                                          <div className="d-flex flex-column col-md-6">
                                                <span className="address-main-header-text">EMAIL</span>
                                                <span className="address-subsection">{individualDepotPersonnelInfo?.email || ""}</span>
                                          </div>
                                          <div className="d-flex flex-column col-md-4">
                                                <span className="address-main-header-text">PHONE</span>
                                                <span className="address-subsection">{individualDepotPersonnelInfo?.phoneNumber || ""}</span>
                                          </div>
                                          <div className="d-flex flex-column col-md-2">
                                          </div>
                                    </div>
                              </div>

                              <div className="table-responsive edit-project-manager-table">
                                    <table className="table table-borderless admintab-depots-details-table ">
                                          <thead className="depot-per-details-header-style">
                                                <tr>
                                                      <th scope="col">{individualDepotPersonnelInfo?.projects?.length || 0} PROJECTS</th>
                                                      <th scope="col">WEB-APP</th>
                                                      <th scope="col"></th>
                                                </tr>
                                          </thead>
                                          <tbody>
                                                {individualDepotPersonnelInfo?.projects && individualDepotPersonnelInfo?.projects.map((item, index) => {
                                                      return (
                                                            <React.Fragment key={index}>
                                                                  <tr className={`depots-tabdetails--body-style`}>
                                                                        <td>{item.name}</td>
                                                                        <td>{item?.grantAppAccess == true ? "Active" : "Inactive"}</td>
                                                                        <td>
                                                                              <button variant="outlined" className="btn-bootstrap-submit-style-pm-remove-detail" style={{ color: "red", borderColor: "red" }} onClick={() => handlRemoveProjectClick(item)}><img className='me-2' src={IconRemove} width={15} height={15} alt="new"></img>
                                                                                    REMOVE
                                                                              </button>
                                                                        </td>
                                                                  </tr>
                                                            </React.Fragment>
                                                      );
                                                })}
                                          </tbody>
                                    </table>
                              </div>

                              <div style={{ height: 60 }}>
                                    <div className="d-flex justify-content-between align-items-center">
                                          <div className="d-flex">
                                                <div className="me-4">
                                                      <Button variant="outlined" style={{ color: "red", borderColor: "red" }} startIcon={<img src={IconRemove} width={15} height={15} alt="new"></img>} onClick={handleUnlistAccountClick}>
                                                            UNLIST ACCOUNT
                                                      </Button>
                                                </div>

                                                <div>
                                                      <Button variant="outlined" style={{ border: "1px solid" }} startIcon={<img src={IconEditRecord} width={17} height={17} alt="new"></img>}
                                                            onClick={handleEditProjectManagerClick}
                                                      >
                                                            EDIT RECORD
                                                      </Button>
                                                </div>
                                          </div>
                                          <Button variant="outlined" style={{ border: "1px solid" }} startIcon={<img src={IconManagerAllocate} width={17} height={17} alt="new"></img>} onClick={handleAssignProjectClick}
                                          >
                                                ASSIGN PROJECT
                                          </Button>
                                    </div>

                              </div>


                        </div>

                        <div className=" first-row-details-goodsin-page">
                        </div>


                  </div>
            </div>

            <CommonModal togal={unlistAccountModal} toggleHandler={handleUnlistAccount}>
                  <UnlistAccountProjectManager selectedData={selectedData} handleBackButtonClick={handleBackButtonClick}
                        setUnlistAccountModel={handleUnlistAccount}
                  />
            </CommonModal>

            <CommonModal togal={isRemoveProjectButtonClick} toggleHandler={handleRemoveProject}>
                  <RemoveProjectManager
                        handleViewRecordButtonClick={handleViewRecordButtonClick}
                        selectedRemoveProjectInfo={selectedRemoveProjectInfo}
                        selectedData={selectedData} handleBackButtonClick={handleBackButtonClick}
                        setRemoveProjectModel={handleRemoveProject}
                  />
            </CommonModal>

            <CommonModal togal={assignProjectModel} toggleHandler={handleAssignProject}>
                  <AssignProject selectedData={selectedData} getAllClientsData={getAllClientsData} handleBackButtonClick={handleBackButtonClick}
                        setAssignProjectModel={handleAssignProject} handleViewRecordButtonClick={handleViewRecordButtonClick}
                  />
            </CommonModal>


      </>;
};